import axios from "axios";
import FormRenderer, {
  handleExternalSubmit,
} from "../../FormRenderer/FormRenderer";
import BreadCrumb from "../../ui/BreadCrumb/BreadCrumb";
import CommonCard from "../../ui/CommonCard/CommonCard";
import classes from "./SubmittedDocument.module.css";
import { useNavigate, useParams } from "react-router-dom";
import { useCallback, useEffect, useState } from "react";
import { useFormioContext } from "@formio/react";
import AuditTrailVertical from "../../AuditTrail/AuditTrailVertical";
import { env } from "../../../constants/env";
import { toast } from "react-toastify";

const letterFormJson = {
  components: [
    {
      label: "Columns",
      columns: [
        {
          components: [
            {
              label: "To:",
              labelPosition: "left-left",
              key: "to",
              type: "textfield",
              input: true,
            },
            {
              label: "Attention:",
              labelPosition: "left-left",
              key: "to1",
              type: "textfield",
              input: true,
            },
          ],
          width: 6,
        },
        { components: [], width: 6 },
      ],
      key: "columns",
      type: "columns",
    },
    {
      label: "RE:",
      key: "re",
      type: "textfield",
      input: true,
    },
    {
      label: "Letter Body",
      key: "letterBody",
      type: "textarea",
      input: true,
    },
    {
      label: "Columns",
      columns: [
        {
          components: [
            {
              label: "Name",
              key: "name",
              type: "textfield",
              input: true,
            },
            {
              label: "Signature",
              key: "premiumsignature",
              type: "signature",
              input: true,
            },
          ],
          width: 3,
        },
        { components: [], width: 3 },
        { components: [], width: 3 },
        {
          components: [
            {
              label: "Date / Time",
              key: "dateTime",
              type: "datetime",
              input: true,
            },
          ],
          width: 3,
        },
      ],
      key: "columns1",
      type: "columns",
    },
    {
      type: "button",
      label: "Submit",
      key: "submit",
      disableOnInvalid: true,
      input: true,
    },
  ],
};

const SubmittedDocument = () => {
  const { submitId } = useParams();
  const [formData, setFormData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [loadingDeliveryForm, setLoadingDeliveryForm] = useState(false);
  const [isSending, setIsSending] = useState(false);
  const [formStage, setFormStage] = useState(null);
  const [deliveryForm, setDeliveryForm] = useState(null);
  const navigate = useNavigate();

  const { Formio, projectUrl } = useFormioContext(); // Get Formio instance and project base URL from context

  const [submissionData, setSubmissionData] = useState(null);

  const [isDownloading, setIsDownloading] = useState(false);

  //   const fetchFunction = useCallback((path) => {
  //     const formio = new Formio(`${projectUrl}/${path}/submission/${submitId}`);
  //     return formio.loadSubmission();
  //   }, [Formio, projectUrl, submitId]);

  // useEffect(() => {
  //   if (id) {
  //     axios
  //       .get(`https://n8n.thutomdm.com/webhook/edrms/forms/?id=${id}`)
  //       .then( async(response) => {
  //         setFormData(response.data[0]);
  //         setLoading(false);
  //         const submittedData = await fetchFunction(response.data[0].path)
  //         console.log("Fetched document:", response.data);
  //         setSubmissionData(submittedData.data)
  //         console.log("DATA:", submittedData.data);
  //       })
  //       .catch((error) => {
  //         console.error("Error fetching document:", error);
  //         setLoading(false);
  //       });
  //   }
  // }, [id]);

  useEffect(() => {
    if (submitId) {
      setLoading(true);

      axios
        .get(`${env.apiUrl}/api/submissions/${submitId}`)
        .then(async (response) => {
          const submissionData = response.data.data;
          const stage = submissionData.submissionStage;

          // ✅ Make sure this callback is async since we use await inside
          if (stage === "usage") {
            const deliveryFormio = new Formio(
              `${projectUrl}/documentdeliveryform`
            );
            const deliveryForm = await deliveryFormio.loadForm();
            setDeliveryForm(deliveryForm);
            console.log("Document Delivery Form:", deliveryForm);
          }

          setFormData(response.data.form);
          setSubmissionData(submissionData);
          setFormStage(submissionData.formStage);
          setLoading(false);

          console.log("Fetched document:", stage);
        })
        .catch((error) => {
          console.error("Error fetching submission:", error);
          setLoading(false);
        });
    }
  }, [submitId]);

  const handleFormSubmit = async (submissionData) => {
    console.log("Submission started:", formData.path);
    setIsSending(true);

    try {
      const formio = new Formio(
        `${projectUrl}/${formData.path}/submission/${submitId}`
      );
      const submission = await formio.saveSubmission({
        data: submissionData,
      });

      console.log("Submission successful:", submission);

      // Send to external webhook
      await fetch(`${env.n8nUrl}/${formData.path}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ submission: submission }),
      });

      navigate("/");
    } catch (err) {
      console.error("Submission failed:", err);
    }

    setIsSending(false);
  };

  const downloadPDFHandler = async () => {
    if (!formData?.path || !submissionData) {
      console.error("Form data or submission data is missing.");
      return;
    }

    setIsDownloading(true);

    console.log("Downloading PDF for form path:", formData.path);
    console.log("With submission data:", submissionData);

    try {
      const response = await fetch(
        `${env.pdfUrl}/generate-pdf/${formData.path}.docx`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Basic " + btoa("admin:password123"),
          },
          body: JSON.stringify({ inputs: submissionData }),
        }
      );

      if (!response.ok) {
        throw new Error("PDF generation failed");
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.download = `${formData?.title || "form-document"}.pdf`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error downloading PDF:", error);
    }

    setIsDownloading(false);
  };

const handleDeliveryFormSubmit = async (submissionData) => {
  // Destructure and add submissionId
    const updatedData = {
      ...submissionData,
      submissionId: submitId, // adjust as needed
    };
  console.log("Delivery form submission started", submissionData);
  setLoadingDeliveryForm(true);
  try {
    const formio = new Formio(`${projectUrl}/form/${deliveryForm._id}`);
    const submission = await formio.saveSubmission({
      data: updatedData,
    });

    toast.success("Sent successfully");
    console.log("Owner ID:", submission);
    setLoadingDeliveryForm(false);
  } catch (err) {
    console.error("Submission failed:", err);
  }
  setLoadingDeliveryForm(false);
};

  if (loading) return <div>Loading...</div>;

  return (
    <>
      <BreadCrumb
        cancelText="cancel"
        createText={
          isDownloading
              ? "Generating..."
              : "Download PDF"
            
        }
        onCreate={downloadPDFHandler}
        disableCreateButton={isDownloading}
      />
      <div className={classes.wrapper}>
        <CommonCard>
          <div className="row">
            <div className={`col-9 ${classes.formContainer}`}>
              {deliveryForm && <FormRenderer
                  title=""
                  formJson={deliveryForm}
                  onSubmit={handleDeliveryFormSubmit}
                  isCreating={true}
                  className="mb-4"
                />}
              <FormRenderer
                title={`${formData?.title} Form`}
                formJson={formData}
                onSubmit={handleFormSubmit}
                submissionData={submissionData}
              />
            </div>
            <div
              className={`col-3 d-flex flex-column gap-3 ${classes.formContainer}`}
            >
              {/* <div className={classes.cardContainer}>
                <h4 className={classes.sectionTitle}>Notes</h4>
              </div> */}
              {/* <div className={classes.cardContainer}>
                <h4 className={classes.sectionTitle}>Classification</h4>
                <h6>Not set</h6>
              </div>
              <div className={classes.cardContainer}>
                <h4 className={classes.sectionTitle}>Assigned to</h4>
                <h6>Michael Hutchins</h6>
              </div> */}
              <div className={classes.cardContainer}>
                <h4 className={classes.sectionTitle}>Template used</h4>
                <h6>{formData?.title}</h6>
              </div>
              <div className={classes.cardContainer}>
                <h4 className={classes.sectionTitle}>Audit trail</h4>
                <AuditTrailVertical />
              </div>
            </div>
          </div>
        </CommonCard>
      </div>
    </>
  );
};
export default SubmittedDocument;
